module.exports = __webpack_public_path__ + "static/media/StyleProfile-Fit.3b2b269e.svg";